export function isNotEmpty(obj: any): boolean {
  for (const key in obj) {
    if (obj[key] !== null) {
      return true; // If any value is not empty, return true
    }
  }
  return false; // If all values are empty, return false
}
